import "./Operations.css";
import Hero from "../../components/Hero/Hero";
import Heading from "../../components/Heading/Heading";
import SubHeading from "../../components/SubHeading/SubHeading";
import ImagesList from "../../components/ImagesList/ImagesList";
import H1 from "../../components/H1/H1";
import usePageTitle from "../../hooks/usePageTitle";

const Operations = () => {
    usePageTitle("Operations");

    const images = [
        {
            title: "Executive services",
            image: "/images/waves/operations1.jpg",
            content:
                "We help leadership teams shape and deliver strategy, setting the operating rhythm, shaping plans and budgets, building KPIs and dashboards, preparing capital formation materials and data rooms, and providing fractional support across finance, operations, technology, and marketing.",
        },
        {
            title: "Australian fund manager services",
            image: "/images/waves/operations2.jpg",
            content:
                "For Australian managers, we provide institutional-grade infrastructure so investment teams can focus on investing. Services include AFSL compliance frameworks for wholesale investors, fund administration and registry, investor reporting, fractional CFO/COO support, and capital formation.",
        },
    ];

    return (
        <div className="page-content operations-page">
            <Hero name="operations">
                <H1>Operations</H1>
            </Hero>

            <section className="padded">
                <div className="container">
                    <Heading>
                        We work alongside founders, managers, and families to turn plans into
                        results. We set cadence, build dashboards, tighten finance and controls, and
                        support capital formation. The goal is steady execution, clean reporting,
                        and momentum that compounds.
                    </Heading>

                    <SubHeading>
                        "We see process as art. Strategy is more than execution; it’s a narrative,
                        dialogue, iteration, and craft. We build operating rhythms that honour both
                        rigour and creativity."
                    </SubHeading>

                    <div className="spacer"></div>

                    <ImagesList data={images} />
                </div>
            </section>
        </div>
    );
};

export default Operations;
